import React from "react";

import ContributorLink from "./contributor-link";

class ContributorByline extends React.Component {
  render() {
    let contributorLinks = null;

    if (this.props.contributors.length === 1) {
      contributorLinks = (<>By <ContributorLink contributor={this.props.contributors[0]} /></>);
    } else if (this.props.contributors.length === 2) {
      contributorLinks = (
        <>
          By{' '}
          <ContributorLink contributor={this.props.contributors[0]} />{' '}
          and{' '}
          <ContributorLink contributor={this.props.contributors[1]} />{' '}
        </>
      );
    } else if (this.props.contributors.length >= 3) {
      contributorLinks = (
        <>
          {this.props.contributors.map((val, idx, arr) => {
            if (idx < arr.length - 1) {
              return (
                <>
                  <ContributorLink contributor={val} />{', '}
                </>
              );
            } else {
              return (
                <>
                  {' and '}<ContributorLink contributor={val} />
                </>
              );
            }
          })}
        </>
      );
    }

    return contributorLinks;
  }
}

export default ContributorByline;